import mutations from './mutations'
import { arrayToObject } from '@/utils/object'
import { notify } from '@/utils/error'
import articles from '@/api/articles'

import { loadItemBuilder, saveItemBuilder, deleteItemBuilder } from '../crudFactory'
const apiEndpoint = 'articles'

function recursiveOrderUpdate (updates, businessUnitId) {
  return new Promise((resolve, reject) => {
    const currentUpdate = updates[0]
    const remainingUpdates = updates.slice(1)
    articles.setSortOrder({ businessUnitId, articleId: currentUpdate.id, sortOrder: currentUpdate.sort_order })
      .then(() => {
        if (remainingUpdates.length) {
          recursiveOrderUpdate(remainingUpdates, businessUnitId)
        }
        resolve()
      })
      .catch(error => {
        reject(error)
      })
  })
}

export default {
  namespaced: true,

  state: {
    items: {},
    inventoryItems: {}
  },

  actions: {
    loadItems: ({ commit, rootState }, search = '') => {
      return new Promise((resolve, reject) => {
        const businessUnitId = rootState.businessUnits.currentBusinessUnit.id
        articles.getAll({ businessUnitId, search })
          .then(response => {
            const items = arrayToObject(response.data.items)
            commit('setElements', { type: 'items', elements: items })
            resolve(items)
          })
          .catch(error => {
            notify(error)
            reject(error)
          })
      })
    },
    loadInventoryItems: ({ commit, rootState }) => {
      return new Promise((resolve, reject) => {
        const businessUnitId = rootState.businessUnits.currentBusinessUnit.id
        articles.getAllForInventory({ businessUnitId })
          .then(response => {
            const items = arrayToObject(response.data.items)
            commit('setElements', { type: 'inventoryItems', elements: items })
            resolve(items)
          })
          .catch(error => {
            notify(error)
            reject(error)
          })
      })
    },
    loadItemWithHeaders: ({ commit, rootState }, { article, headers, businessUnitId }) => {
      return new Promise((resolve, reject) => {
        articles.getById({ businessUnitId, id: article, headers })
          .then(response => {
            resolve(arrayToObject(response.data.items))
          })
      })
    },
    loadItem: loadItemBuilder({ apiEndpoint }),
    saveItem: saveItemBuilder({ apiEndpoint }),
    deleteItem: deleteItemBuilder({ apiEndpoint }),
    updateArticlesOrder ({ rootState }, updates) {
      return new Promise((resolve, reject) => {
        const businessUnitId = rootState.businessUnits.currentBusinessUnit.id
        recursiveOrderUpdate(updates, businessUnitId)
          .then(() => {
            resolve()
          })
          .catch(error => {
            notify(error)
            reject(error)
          })
      })
    }
  },

  mutations: {
    ...mutations
  }
}
